export const columnDefs = [{
  headerName: "Full Name",
  field: "fullName",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
  headerName: "Group Name",
  field: "groupName",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
  headerName: "Group Leader",
  field: "isLeader",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
  headerName: "Gmail Address",
  field: "gmail",
  editable: true,
  cellStyle: { 'text-align': 'left' },
}, {
    headerName: "Men/Women's Culture",
    field: "groupGender",
    editable: true,
    cellStyle: { 'text-align': 'left' },
  }];

export const defaultColumnDefs = {
  sortable: true,
};
